import { createSlice } from "redux-starter-kit";
import preferencesConfig from "./data/preferences.json";

export const prefOptionsSlice = createSlice({
  slice: "prefOptions",
  initialState: {
    options: preferencesConfig,
    activeOption: preferencesConfig[1],
  },
  reducers: {
    setActiveOption: (state, action) => {
      state.activeOption = action.payload;
    },
  },
});
